import type { FacadeMaterialSelection, MaterialLibraryItem } from '@/shared/api/types';

export function isMaterialSelectionSha(value: unknown): value is string {
  return typeof value === 'string' && value.length === 64 && /^[0-9a-f]{64}$/.test(value);
}

/** Identity shape only: physical classification is supplied by the canonical DTO. */
export function requireFacadeMaterialSelection(selection: Partial<FacadeMaterialSelection>): FacadeMaterialSelection {
  if (!Number.isSafeInteger(selection.facadeMaterialId) || !selection.facadeMaterialId || selection.facadeMaterialId <= 0) {
    throw new Error('MATERIAL_SELECTION_ID_REQUIRED');
  }
  if (!isMaterialSelectionSha(selection.facadeMaterialSourceReleaseSha) || !isMaterialSelectionSha(selection.facadeMaterialRowSha256)) {
    throw new Error('MATERIAL_SELECTION_PROVENANCE_REQUIRED');
  }
  return Object.freeze({ facadeMaterialId: selection.facadeMaterialId,
    facadeMaterialSourceReleaseSha: selection.facadeMaterialSourceReleaseSha!, facadeMaterialRowSha256: selection.facadeMaterialRowSha256! });
}

export function captureFacadeMaterialSelection(card: MaterialLibraryItem): FacadeMaterialSelection {
  if (!Array.isArray(card.selectableSurfaces)) throw new Error('MATERIAL_SELECTION_CLASSIFICATION_REQUIRED');
  if (!card.selectableSurfaces.includes('facade')) throw new Error('MATERIAL_SELECTION_SURFACE_UNAVAILABLE');
  if (!Number.isFinite(Number(card.thicknessMm)) || Number(card.thicknessMm) <= 0) throw new Error('MATERIAL_SELECTION_PHYSICAL_GAUGE_REQUIRED');
  return requireFacadeMaterialSelection({ facadeMaterialId: card.id, facadeMaterialSourceReleaseSha: card.sourceReleaseSha, facadeMaterialRowSha256: card.rowSha256 });
}
